import { Component, type ReactNode } from 'react'
import { InlineErrorContext } from '#features/ErrorHandling/InlineErrorContext'

interface InlineErrorBoundaryProps {
  fallback: ReactNode
  children: ReactNode
}

type InlineErrorBoundaryState =
  | {
      hasError: false
    }
  | {
      hasError: true
      error: Error
    }

export class InlineErrorBoundary extends Component<InlineErrorBoundaryProps, InlineErrorBoundaryState> {
  constructor(props: InlineErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, info: { componentStack: string }) {
    console.error(error, info)
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <InlineErrorContext.Provider value={{ error: this.state.error }}>{this.props.fallback}</InlineErrorContext.Provider>
    }

    return this.props.children
  }
}
